import * as Constants from './constants'

export const lsnhapkhoListNhaCCRequest = function lsnhapkhoListNhaCCRequest(formData) {
  return {
    type: Constants.LSNHAPKHO_LIST_NCC_REQUESTING,
    formData
  }
}
export const lsnhapkhoListNhaCCSuccess = function lsnhapkhoListNhaCCSuccess(data) {
  return {
    type: Constants.LSNHAPKHO_LIST_NCC_SUCCESS,
    data
  }
}

export const lsnhapkhoListNhaCCError = function lsnhapkhoListNhaCCError(error) {
  return {
    type: Constants.LSNHAPKHO_LIST_NCC_ERROR,
    error
  }
}

export const lsnhapkhoListKhoRequest = function lsnhapkhoListKhoRequest(formData) {
  return {
    type: Constants.LSNHAPKHO_LIST_KHO_REQUESTING,
    formData
  }
}
export const lsnhapkhoListKhoSuccess = function lsnhapkhoListKhoSuccess(data) {
  return {
    type: Constants.LSNHAPKHO_LIST_KHO_SUCCESS,
    data
  }
}

export const lsnhapkhoListKhoError = function lsnhapkhoListKhoError(error) {
  return {
    type: Constants.LSNHAPKHO_LIST_KHO_ERROR,
    error
  }
}

export const lsnhapkhoListRequest = function lsnhapkhoListRequest(formData) {
  return {
    type: Constants.LSNHAPKHO_LIST_REQUESTING,
    formData
  }
}

export const lsnhapkhoListSuccess = function lsnhapkhoListSuccess(data) {
  return {
    type: Constants.LSNHAPKHO_LIST_SUCCESS,
    data
  }
}

export const lsnhapkhoListError = function lsnhapkhoListError(error) {
  return {
    type: Constants.LSNHAPKHO_LIST_ERROR,
    error
  }
}

export const lsnhapkhoItemRequest = function lsnhapkhoItemRequest(formData) {
  return {
    type: Constants.LSNHAPKHO_ITEM_REQUESTING,
    formData
  }
}

export const lsnhapkhoItemSuccess = function lsnhapkhoItemSuccess(data) {
  return {
    type: Constants.LSNHAPKHO_ITEM_SUCCESS,
    data
  }
}

export const lsnhapkhoItemError = function lsnhapkhoItemError(error) {
  return {
    type: Constants.LSNHAPKHO_ITEM_ERROR,
    error
  }
}
export const lsnhapkhoPrintRequest = function lsnhapkhoPrintRequest(formData) {
  return {
    type: Constants.LSNHAPKHO_PRINT_REQUESTING,
    formData
  }
}

export const lsnhapkhoPrintSuccess = function lsnhapkhoPrintSuccess(data) {
  return {
    type: Constants.LSNHAPKHO_PRINT_SUCCESS,
    data
  }
}

export const lsnhapkhoPrintError = function lsnhapkhoPrintError(error) {
  return {
    type: Constants.LSNHAPKHO_PRINT_ERROR,
    error
  }
}
export const lsnhapkhoExportXlsRequest = function lsnhapkhoExportXlsRequest(formData, callback) {
  return {
    type: Constants.LSNHAPKHO_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const lsnhapkhoExportXlsSuccess = function lsnhapkhoExportXlsSuccess(data) {
  return {
    type: Constants.LSNHAPKHO_EXPORT_XLS_SUCCESS,
    data
  }
}

export const lsnhapkhoExportXlsError = function lsnhapkhoExportXlsError(error) {
  return {
    type: Constants.LSNHAPKHO_EXPORT_XLS_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/LsNhapKho/actions.js